import { useTranslate } from "@similarweb/i18n-provider";
import { Salesloft } from "@similarweb/icons";
import { TextCell, TooltipTextAnchorCell } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import type { PlaybookCadence } from "../../types/playbooks.types";

import { StyledConnectSalesloftButton } from "./styles";

type PlaybooksTableCadenceCellProps = {
    cadence: PlaybookCadence | null;
    isSalesloftReconnectRequired: boolean;
    onConnectSalesloft: () => void;
};

const ConnectSalesloftButton = ({ onClick }: { onClick: () => void }) => {
    const { translate } = useTranslate();

    return (
        <Flex
            alignItems="center"
            margin="0 8px"
        >
            <StyledConnectSalesloftButton
                type="flat"
                buttonHtmlType="button"
                height="auto"
                label={translate("si.playbooks.column.cadence.connect_salesloft")}
                dataAutomation="playbooks-cadence-connect-salesloft"
                onClick={onClick}
            >
                <Salesloft
                    size="xs"
                    color={colorsPalettes.carbon["500"]}
                    aria-hidden
                />
            </StyledConnectSalesloftButton>
        </Flex>
    );
};

export const PlaybooksTableCadenceCell = ({
    cadence,
    isSalesloftReconnectRequired,
    onConnectSalesloft,
}: PlaybooksTableCadenceCellProps) => {
    const { translate } = useTranslate();

    if (cadence) {
        return (
            <TooltipTextAnchorCell
                href={cadence.url}
                target="_blank"
                tooltipContent={translate("si.playbooks.column.cadence.view_in_salesloft")}
                dataAutomation="playbooks-cadence-link"
            >
                {cadence.name}
            </TooltipTextAnchorCell>
        );
    }

    if (isSalesloftReconnectRequired) {
        return <ConnectSalesloftButton onClick={onConnectSalesloft} />;
    }

    return <TextCell>-</TextCell>;
};
